import { LOGO_URL } from "../lib/api";

export const LogoBadge = ({ size = "w-14 h-14", rounded = "rounded-2xl", className = "" }) => (
  <div
    className={`${size} ${rounded} overflow-hidden bg-gradient-to-b from-[#FAFAF7] to-[#F1F1F0] border border-gray-100 flex items-center justify-center shrink-0 ${className}`}
  >
    <img src={LOGO_URL} alt="LaunchBS" loading="lazy" decoding="async" className="w-[88%] h-[88%] object-contain" />
  </div>
);
